import { IconeCarteira } from '@/components/atoms/Icones/IconeCarteira';
import { BreadcrumbLink } from '@/components/molecules/Breadcrumbs';

export const breadcrumbMinhaCarteira: BreadcrumbLink = {
  atual: false,
  href: '/minha-conta/minha-carteira',
  texto: 'Minha Carteira',
  Icone: IconeCarteira,
};
